import { defineGroupFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

// Founder Info is a group filter - clicking it shows child filters in a submenu
export const founderInfoDescriptor = defineGroupFilter({
  definition: {
    id: FilterId.FOUNDER_INFO,
    name: 'Founder Info',
    type: FilterType.GROUP,
    isVisible: true,
    children: [
      FilterId.FOUNDER_ETHNICITY,
      FilterId.FOUNDER_GENDER,
      FilterId.FOUNDER_COMPANY,
      FilterId.FOUNDER_PREVIOUS_SCHOOL,
    ],
  },
});
